"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Arrow = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _zIndices = _interopRequireDefault(require("../zIndices"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BACKGROUND_COLOR = '#474747';
var ARROW_HEIGHT = 4;
var ARROW_WIDTH = 8;

var Container = _styledComponents.default.div.withConfig({
  displayName: "tooltipStyles__Container",
  componentId: "ujy74y-0"
})(["position:relative;z-index:", ";display:flex;flex-direction:column;justify-content:center;align-items:center;max-width:400px;padding:0.5em;margin:", "px;background-color:", ";border-radius:3px;color:#fff;font-size:13px;@media (max-width:500px){max-width:300px;}"], _zIndices.default.tooltip, ARROW_HEIGHT, BACKGROUND_COLOR);

exports.Container = Container;

var Arrow = _styledComponents.default.div.withConfig({
  displayName: "tooltipStyles__Arrow",
  componentId: "ujy74y-1"
})(["position:absolute;width:", "px;height:", "px;&::before{content:'';display:block;width:0;height:0;margin:auto;border-style:solid;}&[data-placement*='bottom']{top:0;left:0;width:", "px;height:", "px;margin-top:-", "px;&::before{border-color:transparent transparent ", " transparent;border-width:0 ", "px ", "px ", "px;}}&[data-placement*='top']{bottom:0;left:0;width:", "px;height:", "px;margin-bottom:-", "px;&::before{border-color:", " transparent transparent transparent;border-width:", "px ", "px 0 ", "px;}}&[data-placement*='right']{left:0;width:", "px;height:", "px;margin-left:-", "px;&::before{border-color:transparent ", " transparent transparent;border-width:", "px ", "px ", "px 0;}}&[data-placement*='left']{right:0;width:", "px;height:", "px;margin-right:-", "px;&::before{border-color:transparent transparent transparent ", ";border-width:", "px 0 ", "px ", "px;}}"], ARROW_WIDTH, ARROW_WIDTH, ARROW_WIDTH, ARROW_HEIGHT, ARROW_HEIGHT, BACKGROUND_COLOR, ARROW_WIDTH / 2, ARROW_HEIGHT, ARROW_WIDTH / 2, ARROW_WIDTH, ARROW_HEIGHT, ARROW_HEIGHT, BACKGROUND_COLOR, ARROW_HEIGHT, ARROW_WIDTH / 2, ARROW_WIDTH / 2, ARROW_HEIGHT, ARROW_WIDTH, ARROW_HEIGHT, BACKGROUND_COLOR, ARROW_WIDTH / 2, ARROW_HEIGHT, ARROW_WIDTH / 2, ARROW_HEIGHT, ARROW_WIDTH, ARROW_HEIGHT, BACKGROUND_COLOR, ARROW_WIDTH / 2, ARROW_WIDTH / 2, ARROW_HEIGHT);

exports.Arrow = Arrow;